// 全ページ共通の JS
import 'instant.page';
import './banner.js';

document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const ua = window.navigator.userAgent.toLowerCase();

  // UA 判定でブラウザクラスを付与
  if (ua.match(/msie/i) || ua.match(/rident/i)) {
    const m = ua.match(/((msie|msie)\s|rv:)([\d\.]+)/);
    if (m) body.classList.add('ie', 'ie' + parseInt(m[3]));
  } else if (ua.match(/edge/i)) {
    body.classList.add('edge');
  } else if (ua.match(/ipad/i) || (ua.match(/android/i) && !ua.match(/mobile/i))) {
    // iPad や Android タブレットでは固定幅にする
    const meta = document.querySelector('head>meta[name="viewport"]');
    if (meta) {
      meta.setAttribute('content', meta.getAttribute('content').replace(/width=(\d+|device-width)/g, 'width=1150'));
    }
  }

  // 非モバイルでは tel: クリックを無効化
  const isMobile = /iphone/.test(ua) || /android(.+)?mobile/.test(ua);
  if (!isMobile) {
    document.querySelectorAll('a[href^="tel:"]').forEach((a) => {
      a.addEventListener('click', (e) => e.preventDefault());
    });
  }

  // 採用ページの応募方法アコーディオン
  const applicationInfos = document.querySelectorAll('section#application .info');
  applicationInfos.forEach((info) => {
    info.classList.add('close');
    const contents = info.querySelector('.contents');
    if (contents) contents.style.display = 'none';
    const h4 = info.querySelector('h4');
    if (h4) {
      h4.addEventListener('click', () => {
        info.classList.toggle('close');
        if (contents) {
          contents.style.display = info.classList.contains('close') ? 'none' : 'block';
        }
      });
    }
  });

  // ページ内リンクのスムーズスクロール
  const scrollToTarget = (selector) => {
    const target = document.querySelector(selector);
    if (!target) return;
    const header = document.querySelector('header');
    const offset = header ? header.offsetHeight : 0;
    const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top, behavior: 'smooth' });
  };

  body.addEventListener('click', (e) => {
    const a = e.target.closest('a[href*="#"]');
    if (!a) return;
    const href = a.getAttribute('href');
    const [path, hash] = href.split('#');
    if (path === '' || path === location.pathname) {
      e.preventDefault();
      document.querySelectorAll('header nav').forEach((n) => n.classList.remove('visible'));
      if (hash) scrollToTarget('#' + hash);
    }
  });

  document.querySelectorAll('#menu_btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('header nav').forEach((n) => n.classList.add('visible'));
    });
  });

  document.querySelectorAll('header>nav').forEach((nav) => {
    nav.addEventListener('click', (e) => {
      const t = e.target;
      if (t === nav || t.id === 'close_btn' || t.closest('#close_btn')) {
        nav.classList.remove('visible');
      }
    });
  });

  window.addEventListener('load', () => {
    if (location.hash) scrollToTarget(location.hash);
  });
});
